<template>
    <div id="heroBlockRoot">
        <div id="hero-block-wrapper" class="heroBlockWrapper">
            <a
                v-if="storyTitle && storyLink && storyCat"
                target="_blank"
                :href="storyLink"
            >
                <div id="heroImgWrapper" class="heroImgWrapper">
                    <img id="heroImg" :src="storyImg" />
                </div>
                <div class="heroBottomBannerWrapper">
                    <div class="heroBottomBanner">
                        <div class="heroBottomBannerCategory">
                            {{ storyCat }}
                        </div>
                        <div
                            class="heroBottomBannerTitle"
                            :title="storyTitle.full"
                        >
                            {{ storyTitle.truncated }}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "hero-block",
    props: ["story", "category"],
    data() {
        return {
            storyTitle: null,
            storyDesc: null,
            storyLink: null,
            storyCat: null,
            storyImg: null,
        };
    },
    mounted() {
        if (this.story) {
            const { story } = this;
            if (story.title) this.storyTitle = this.getTitleText(story.title);
            if (story.description)
                this.storyDesc = this.getStoryDesc(story.description);
            if (story.link) this.storyLink = story.link;
            if (this.category) {
                this.storyCat = this.titleCase(this.category);
                if (story.thumbnail && story.thumbnail.url) {
                    this.storyImg = story.image.url;
                } else {
                    const random =
                        Math.floor(Math.random() * Math.floor(3)) + 1; // 1 2 or 3
                    this.storyImg = `/assets/images/home/hero/freshyhero_${this.getImageString(
                        this.category
                    )}_${random || 0}.jpg')`;
                }
            }
        }
    },
    methods: {
        getImageString(str) {
            return str.replace(" ", "");
        },
        titleCase(str) {
            str = str.toLowerCase().split(" ");
            for (let i = 0; i < str.length; i++) {
                str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
            }
            return str.join(" ");
        },
        getTitleText(title) {
            const MAX_LENGTH = 198;

            const returnText = this.decodeHTMLString(title);

            if (returnText.length > MAX_LENGTH - 3)
                return {
                    truncated: `${returnText.substring(0, MAX_LENGTH)}...`,
                    full: returnText,
                };
            return { truncated: returnText, full: returnText };
        },
        decodeHTMLString(str) {
            return str.replace(/&#(\d+);/g, (match, dec) =>
                String.fromCharCode(dec)
            );
        },
        getStoryDesc(html) {
            const MAX_LENGTH = 325;

            const temporalDivElement = document.createElement("div");
            temporalDivElement.innerHTML = html;
            const returnText = this.decodeHTMLString(
                temporalDivElement.textContent ||
                    temporalDivElement.innerText ||
                    ""
            );

            if (returnText.length > MAX_LENGTH - 3) {
                const returnString = `${returnText.substring(
                    0,
                    MAX_LENGTH
                )}...`;
                return returnString;
            }
            return returnText;
        },
    },
};
</script>

<style scoped>
#hero-wrapper a {
    text-decoration: none;
}

#hero-wrapper {
    margin-bottom: 50px;
}

#heroBlockRoot {
    position: relative;
    overflow: hidden;
}

.heroBlockWrapper {
    height: 200px;
    max-width: 325px;
    margin: 0 auto;
    background-size: cover;
}

.heroBlockWrapper a {
    width: 100%;
    max-width: 325px;
    height: 100%;
    position: absolute;
}

.heroBottomBannerWrapper {
    height: 75px;
    background: #0757e7;
    color: #fff;
    box-sizing: border-box;
    padding: 5px 10px 5px 10px;
    position: relative;
    bottom: 78px;
    opacity: 0.85;
    /*
    box-shadow: 15px 0px 20px 22px #0756e7;
    -moz-box-shadow: 15px 0px 20px 22px #0756e7;
    -webkit-box-shadow: 15px 0px 20px 22px #0756e7;
    */
}

.heroBottomBannerCategory {
    font-weight: bold;
    font-size: 0.75rem;
    color: #ffe62a;
}

.heroBottomBannerTitle {
    font-size: 0.8rem;
    line-height: 1rem;
    height: 50px;
    box-sizing: border-box;
}

#heroImg {
    height: 200px;
    width: 325px;
}
</style>
